<ng-container *transloco="let t">
    <app-admin-modal-layout
            [title]="'league.competitor.details'"
            [showActions]="false"
            (onClose)="onClose()"
    >
        <div class="pb-4">
            <div class="competitor-grid">
                <div class="d-flex flex-column gap-6">
                    <div class="flex-base">
                        <span class="fs-13 fw-600 color-grey-neutral-900">{{ competitor?.firstName }} {{ competitor?.lastName }}</span>
                        <span class="fs-11 color-grey-neutral-400">ID {{ competitor?.id }}</span>
                    </div>

                    <div class="d-flex align-items-start gap-32">
                        <div class="d-flex flex-column gap-2">
                            <span class="fs-10 color-grey-neutral-500">{{ t('app.common.birthDay') }}</span>
                            <span class="fs-12 fw-500 color-grey-neutral-700">{{ competitor?.birthday ?? '' | localizedDate:'shortDate' }}</span>
                        </div>
                        <div class="d-flex flex-column gap-2">
                            <span class="fs-10 color-grey-neutral-500">{{ t('app.common.gender') }}</span>
                            <span class="fs-12 fw-500 color-grey-neutral-700">{{ competitor?.sex ? t('app.common.gender.short.' + competitor!.sex) : '-' }}</span>
                        </div>
                        <div class="d-flex flex-column gap-2">
                            <span class="fs-10 color-grey-neutral-500">{{ t('app.common.country') }}</span>
                            <span class="fs-12 fw-500 color-grey-neutral-700">{{ competitor?.country ? (competitor!.country | country) : '-' }}</span>
                        </div>
                        <div class="d-flex flex-column gap-2">
                            <span class="fs-10 color-grey-neutral-500">{{ t('app.common.category') }}</span>
                            <span class="fs-12 fw-500 color-grey-neutral-700">{{ competitor?.categoryItemLabel ?? '-' }}</span>
                        </div>
                    </div>

                    <div class="flex-base">
                        <span class="fs-10 color-grey-neutral-500">{{ t('app.common.races') }}</span>
                        @if (competitor?.rounds?.length) {
                        <div class="races-list">
                            @for (race of competitor!.rounds!; track race.id) {
                        <div class="status-badge orange">
                            <span class="pe-2">{{race.id}}</span>
                            <span class="pe-2">-</span>
                            <span class="fw-500">{{raceNames.get(race.id!)}}</span>
                        </div>
                        }
                        </div>
                        } @else {
                        <span class="fs-12 fw-500 color-grey-neutral-700">-</span>
                        }
                    </div>

                </div>
                <div class="d-flex justify-content-between align-items-end flex-column">
                    <div>
                        @if (competitor?.matchStatus) {
                        <div class="status-badge"
                             [class.green]="competitor!.matchStatus === MatchStatus.FULL_MATCH"
                             [class.blue]="competitor!.matchStatus === MatchStatus.MERGED"
                             [class.gray]="competitor!.matchStatus === MatchStatus.DUPLICATE"
                             [class.gray-bck-blue-clr]="competitor!.matchStatus === MatchStatus.MERGED_DUPLICATE"
                       >
                        <span class="fw-500">
                        {{ t('league.competitor.match.status.' + competitor!.matchStatus) | uppercase}}
                        </span>
                        </div>
                        }

                    </div>
                </div>
            </div>
        </div>

    </app-admin-modal-layout>
</ng-container>